import { api } from "@mcp/services";
import { Api } from "@mcp/services/src/services";

// @ts-ignore
export const mApi: Api<unknown> = api({ baseUrl: process.env.HTTP_ENDPOINT });
